// Whether a driver has accounted for the history a job listing asks for.
//
// Behavioural mirror of api/src/lib/employmentHistoryCoverage.ts — keep the two
// answering identically. The month arithmetic itself now lives in
// src/utils/date/monthPeriods, shared with everything else that reasons about
// spans of months; only the rule below is specific to employment.

import {
  MONTHS_PER_YEAR,
  currentMonthIndex,
  isFullyCovered,
  toMonthIndex,
} from 'src/utils/date/monthPeriods'

export interface EmploymentCoverageEntry {
  startDate?: Date | string | null
  endDate?: Date | string | null
}

export const isEmploymentHistoryCovered = (
  entries: EmploymentCoverageEntry[],
  minYears?: number | null,
  now: Date = new Date()
): boolean => {
  if (!minYears || minYears <= 0) return true

  const end = currentMonthIndex(now)
  // Exactly N years of months ending with the current one — 120 for ten — the
  // same window the employment-history bar draws, mirrored by the API.
  const window = { start: end - minYears * MONTHS_PER_YEAR + 1, end }

  const periods = (entries ?? [])
    .map((entry) => ({
      start: toMonthIndex(entry.startDate),
      end: toMonthIndex(entry.endDate),
    }))
    .filter(
      (period): period is { start: number; end: number | null } =>
        period.start !== null
    )

  return isFullyCovered(periods, window)
}
